import { supabase } from './supabase';

/**
 * Sends a transactional email via the Resend edge function.
 * @param {string} to - Recipient email address
 * @param {string} type - Email type: 'email_confirmation' | 'password_reset' | 'welcome' | 'submission_approved' | 'transactional'
 * @param {object} data - Template-specific data (name, confirmationUrl, resetUrl, etc.)
 */
export const sendEmail = async (to, type, data = {}) => {
  try {
    const { data: result, error } = await supabase?.functions?.invoke('send-email', {
      body: { to, type, data }
    });

    if (error) {
      console.error('Email send error:', error);
      return { success: false, error: error?.message };
    }

    return { success: true, id: result?.id };
  } catch (err) {
    console.error('Email service error:', err);
    return { success: false, error: err?.message };
  }
};

/**
 * Send a custom-branded email confirmation
 */
export const sendEmailConfirmation = (to, name, confirmationUrl) =>
  sendEmail(to, 'email_confirmation', { name, confirmationUrl });

/**
 * Send a custom-branded password reset email
 */
export const sendPasswordReset = (to, name, resetUrl) =>
  sendEmail(to, 'password_reset', { name, resetUrl });

/**
 * Send a welcome email after account verification
 */
export const sendWelcomeEmail = (to, name) =>
  sendEmail(to, 'welcome', { name });

/**
 * Send a submission approved notification
 */
export const sendSubmissionApproved = (to, name, campaignName, amount) =>
  sendEmail(to, 'submission_approved', { name, campaignName, amount });
